export default "__VITE_ASSET__mdzHciOn__"